import { ISelectItem } from '@/models/select';

export const AUTH_METHODS = {
  password: 'password',
  privateKey: 'privateKey',
} as const;

export const AUTH_METHODS_OPTIONS: ISelectItem[] = Object.values(AUTH_METHODS).map((method) => ({
  id: method,
  label: method,
}));
